namespace $ {

	export let $hyoo_marked_cut = $mol_regexp.from([
		'--',
		$mol_regexp.line_end,
	])
	
}
